import React from 'react';
import { getMaterialHoverLabel } from '../shared/materialLabels';
import SkeletonImage from './SkeletonImage';

export default function MaterialGrid({ mat, altFallback = 'Evolution material' }) {
    if (!mat) {
        return null;
    }

    const slots = [1, 2, 3, 4, 5].filter((index) => mat[`mat${index}`]);
    if (slots.length === 0) {
        return null;
    }

    return (
        <ul className="gs-mat-grid" role="list">
            {slots.map((index) => {
                const src = mat[`mat${index}`];
                const amount = mat[`mat${index}amt`];
                const label = getMaterialHoverLabel(mat, index);
                const qty = amount != null && amount !== '' ? `×${amount}` : null;
                const aria = [label, qty].filter(Boolean).join(', ');

                return (
                    <li key={index} className="gs-mat-cell">
                        <span
                            className="gs-mat-tip"
                            tabIndex={label ? 0 : undefined}
                            aria-label={aria || altFallback}
                        >
                            <SkeletonImage
                                src={src}
                                alt=""
                                frameClassName="gs-skeleton-frame--mat"
                                loading="lazy"
                            />
                            {qty ? (
                                <span className="gs-mat-cell__qty" aria-hidden="true">
                                    {qty}
                                </span>
                            ) : null}
                            {label ? (
                                <span className="gs-mat-tip__bubble" role="tooltip">
                                    {label}
                                </span>
                            ) : null}
                        </span>
                        {label ? (
                            <span className="gs-mat-cell__name" title={label}>
                                {label}
                            </span>
                        ) : null}
                    </li>
                );
            })}
        </ul>
    );
}
